export default "/images/timer.svg?2ed7ace2bd0ad1dd7b995ae09a6e4d69";